import { Col, Row } from '@advanza/grid'
import { Button, PreIcon } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'
import style from 'components/providers/testClickConfirmModal.module.css'
import React from 'react'

const TestClickConfirmModal = NiceModal.create(({ onConfirm }) => {
    const modal = useModal()

    const onClose = () => {
        modal.resolve()
        modal.hide()
    }

    return (
        <BaseModal onClose={onClose}>
            <BaseModalHeader className={style.headerText}>Confirm Test Click</BaseModalHeader>
            <BaseModalMainContent>
                <PreIcon icon="info" primColor>
                    you sure you want to add a test click?
                </PreIcon>
            </BaseModalMainContent>
            <BaseModalFooter className={style.footer}>
                <Row between="xs" middle="xs">
                    <Col x>
                        <Button appearance="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                    </Col>
                    <Col x>
                        <Button
                            appearance="primary"
                            onClick={() => {
                                onConfirm()
                                onClose()
                            }}>
                            Confirm
                        </Button>
                    </Col>
                </Row>
            </BaseModalFooter>
        </BaseModal>
    )
})

export default TestClickConfirmModal
